import gql from 'graphql-tag';

export const CREATE_MUTATION = gql`
  mutation createUpsell($data: UpsellCreateInput!) {
    node: createUpsell(data: $data) {
      id
      displayOrder
      name {
        id
        se
        en
        es
        no
      }
      items {
        id
        title
      }
    }
  }
`;

export const UPDATE_MUTATION = gql`
  mutation updateUpsell($id: ID!, $data: UpsellUpdateInput!) {
    node: updateUpsell(where: { id: $id }, data: $data) {
      id
      displayOrder
      name {
        id
        se
        en
        es
        no
      }
    }
  }
`;

export const NODE_QUERY = gql`
  query getNode($id: ID!) {
    node: Upsell(id: $id) {
      id
      createdAt
      updatedAt
      name {
        id
        se
        en
        es
        no
      }
      company {
        id
      }
      usedOn {
        id
        title
        defaultPrice
      }
      itemsUsedOn {
        id
        title
        titleLang {
          id
          en
          se
          es
          no
        }
        defaultPrice
      }
      items {
        id
        title
        titleLang {
          id
          se
          en
          es
          no
        }
        defaultPrice
      }
      enableMultiSelect
      hideInPOS
      hideInEPOS
      hideInApp
      displayOrder
    }
  }
`;

export const UPDATE_UPSELL_METADATA = gql`
  mutation UpdateUpsellsMetadata($input: UpdateUpsellMetadataInput!) {
    updateUpsellMetadata(input: $input) {
      success
      error
    }
  }
`;
